/* -----------------------------------------------

Welcome to the main JS file Mention.com.

This file contains global functions and scripts that must be used globally.

All the JS files are compiled into one composite file with Gulp.

**Guidelines guidance**

- Always respect the following naming convention for file: men-nameoffile.js

- Every file that is not prefixed with "men-" is either a vendor file
(e.g particles.js or list.js) or a config file or a composite

- Use camelCase for naming your functions.
- Indentation is tab = 2 spaces based

 ----------------------------------------------- */

// This the global JS file for Mention

// check segmentID
var su_anonymous_id;
var segmentID;

analytics.ready(function() {
  	segmentID = analytics.user().id();
  	if (segmentID !== null && segmentID.length > 0) {
  		// exist, ok
  		segmentID = analytics.user().id();
  	} else {
  		// does not exist, switch to anonymous
  		su_anonymous_id = analytics.user().anonymousId();
  		segmentID = su_anonymous_id;
  	}
});


function redirectSupPriv(){
  if (location.href === "https://mention.com/en/#privacy"){
    window.location.replace("https://privacy.mention.com/en/");
  }
  if (location.href === "https://mention.com/en/#tos"){
    window.location.replace("https://en.support.mention.com/article/443-terms-of-service");
  }
}

redirectSupPriv();

// track "fake" free trial form (home + feature page)
$(".js-freetrial-form").submit(function(e) {
	e.preventDefault();
	sendToFreeTrial(e.target);
});

function sendToFreeTrial(form){
  var inputvalue = $(form).find(".js-freetrial-input").val();
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if(re.test(String(inputvalue).toLowerCase())) {
    analytics.track('GAevent', {
      eventCategory : 'free trial',
      eventAction :'form submitted',
      eventLabel: '//'
    });
    dataLayer.push({
      event: 'virtualPageview',
      virtualPageURL: window.location.pathname + '/step-2',
      virtualPageTitle: document.title + ' - Step 2'
    });
  	var url = window.location.href;
  	var splitter = url.split('/');
  	var lang = splitter[3];
  	location.href = 'https://web.mention.com/'+ lang +'#signup/marketing/'+encodeURIComponent(inputvalue);
  }
}


// Facebook SDK
var fbLoginStatus = null;
 window.fbAsyncInit = function() {
 	FB.init({
 		appId      : 379917842024803,
 		xfbml      : true,
 		version    : 'v2.4',
		status     : true
 	});
 };

 (function(d, s, id){
 	 var js, fjs = d.getElementsByTagName(s)[0];
 	 if (d.getElementById(id)) {return;}
 	 js = d.createElement(s); js.id = id;
 	 js.src = "//connect.facebook.net/en_US/sdk.js";
 	 fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));

// }

	$(window).load(function() {

		// The body is loaded
		$("body").addClass("loaded");

		/*
		* Counter of mentions
		*/

		if (!Date.now) {
			Date.now = function() { return new Date().getTime(); };
		}

		var commafy = function(num) {
			var str = num.toString().split('.');
			if (str[0].length >= 5) {
				str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
			}
			if (str[1] && str[1].length >= 5) {
				str[1] = str[1].replace(/(\d{3})/g, '$1 ');
			}
			return str.join('.');
		};

		// Calculate the current timestamp
		var currentTimestamp = Math.floor(Date.now() / 1000);

		// Calculate the second which passed since the reference date
		var refDate = "23-09-2016";
		refDate = refDate.split("-");
		var refTimestamp = refDate[1]+"/"+refDate[0]+"/"+refDate[2];
		var secondPassed = currentTimestamp - Math.floor(new Date(refTimestamp).getTime() / 1000);

		// Calculate and initialize Mention count (ref nb + 63 mentions per s)
		var mentionCount = 8272157131 + secondPassed * 63;
		$(".mention-recap__nb").html(commafy(mentionCount));

		// Update the counter every 5s (+126)
		setInterval(function() {
			mentionCount = mentionCount + 126;
			$(".mention-recap__nb").html(commafy(mentionCount));
		}, 2000);

		// Click on the language switcher to change lang
		$(".language-switcher__choice").change(function() {
			// Get current and new lang
			var that = $(this),
				currentLang = that.attr("data-current"),
				newLang = that.find('option:selected').attr("value");
			// Patch the lang in the URL and refresh page
			window.location = (window.location.href).replace("/" + currentLang + "/", "/" + newLang + "/");
		});

		// In the footer click on the section to expand
		$(".footer-column").click(function(){
      if ($(window).width() < 980){
  			var that = $(this);
  			if(that.hasClass("footer-column--5")) { return; }
  			var newHeight = that.find(".footer-column__title").height() + that.find(".footer-items").height() + 30;
  			if(that.hasClass("footer-column--open")) {
  				that.animate({"height": "50px"}, 500);
  			} else {
  				that.animate({"height": newHeight}, 500);
  			}
  			that.toggleClass("footer-column--open");
      }
		});

		// Enterprise Features Slick Influencers

		$('.fullpic_slider').slick({
			slidesToShow: 1,
		  	slidesToScroll: 1,
		  	arrows: false,
		  	autoplaySpeed:5000,
			centerMode: true,
			fade: true,
		  	asNavFor: '.threeBlocks'
		});
		$('.threeBlocks').slick({
		  	slidesToShow: 3,
		  	slidesToScroll: 1,
		  	asNavFor: '.fullpic_slider',
		  	dots: true,
		  	centerMode: true,
		  	focusOnSelect: true
		});

		// Alternative to Testimonials

		$('.slick-testi').slick({
			slidesToShow: 1,
	  		slidesToScroll: 1,
	  		arrows: false,
	  		fade: true,
	  		asNavFor: '.slick-author'
		});

		$('.slick-author').slick({
	  		slidesToShow: 2,
	  		slidesToScroll: 1,
	  		asNavFor: '.slick-testi',
	  		dots: false,
	  		centerMode: true,
	  		focusOnSelect: true
		});


		// Carousel testimonials
		$("#carousel-testimonial").slick({
			dots: true,
			arrows: false,
			infinite: true,
			cssEase: 'linear',
			variableWidth: false,
			autoplay: true,
			slidesToShow: 1,
			draggable: false,
			fade: true,
			speed: 700,
			autoplaySpeed: 7000,
			appendDots: ".customertestimonials__dots"
		});

		//Case Study slick
		$('#caseStudySlider .slider').slick({
			centerMode: true,
		    dots: false,
		    focusOnSelect: true,
		    autoplay:true,
		    autoplaySpeed: 4000,
		    nextArrow: $('#caseStudySlider .controls .next'),
		    prevArrow: $('#caseStudySlider .controls .prev'),
		    infinite: false,
		    variableWidth: true,
		});

	    $('#caseStudySlider .slider').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
	        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
	        var status = $('#caseStudySlider .counter');
	        var i = (currentSlide ? currentSlide : 0) + 1;
	        status.text(i + '/' + slick.slideCount);
	    });

		//Case Study slick
		$('#screenshotsSlider .slider').slick({
			centerMode: true,
		    dots: false,
		    autoplay:true,
		    autoplaySpeed: 4000,
		    infinite: true,
		    focusOnSelect: true,
		    variableWidth: true,
		});

		$(function() {
		  // init atvs
		    atvImg();
		    $('.atvImg').on('click', function(){
		    	$(this).hide();
		    	$('.video_block iframe').show();
		    	$(".video_block iframe")[0].src += "&autoplay=1";
    			ev.preventDefault();
		    });
		});


function atvImg(){

	var d = document,
		de = d.documentElement,
		bd = d.getElementsByTagName('body')[0],
		htm = d.getElementsByTagName('html')[0],
		win = window,
		imgs = d.querySelectorAll('.atvImg'),
		totalImgs = imgs.length,
		supportsTouch = 'ontouchstart' in win || navigator.msMaxTouchPoints;

	if(totalImgs <= 0){
		return;
	}

	// build HTML
	for(var l=0;l<totalImgs;l++){

		var thisImg = imgs[l],
			layerElems = thisImg.querySelectorAll('.atvImg-layer'),
			totalLayerElems = layerElems.length;

		if(totalLayerElems <= 0){
			continue;
		}

		while(thisImg.firstChild) {
			thisImg.removeChild(thisImg.firstChild);
		}

		var containerHTML = d.createElement('div'),
			shineHTML = d.createElement('div'),
			shadowHTML = d.createElement('div'),
			layersHTML = d.createElement('div'),
			layers = [];

		thisImg.id = 'atvImg__'+l;
		containerHTML.className = 'atvImg-container';
		shineHTML.className = 'atvImg-shine';
		shadowHTML.className = 'atvImg-shadow';
		layersHTML.className = 'atvImg-layers';

		for(var i=0;i<totalLayerElems;i++){
			var layer = d.createElement('div'),
				imgSrc = layerElems[i].getAttribute('data-img');

			layer.className = 'atvImg-rendered-layer';
			layer.setAttribute('data-layer',i);
			layer.style.backgroundImage = 'url('+imgSrc+')';
			layersHTML.appendChild(layer);

			layers.push(layer);
		}

		containerHTML.appendChild(shadowHTML);
		containerHTML.appendChild(layersHTML);
		containerHTML.appendChild(shineHTML);
		thisImg.appendChild(containerHTML);

		var w = thisImg.clientWidth || thisImg.offsetWidth || thisImg.scrollWidth;
		thisImg.style.transform = 'perspective('+ w*3 +'px)';

		if(supportsTouch){
			win.preventScroll = false;

	        (function(_thisImg,_layers,_totalLayers,_shine) {
				thisImg.addEventListener('touchmove', function(e){
					if (win.preventScroll){
						e.preventDefault();
					}
					processMovement(e,true,_thisImg,_layers,_totalLayers,_shine);
				});
	            thisImg.addEventListener('touchstart', function(e){
	            	win.preventScroll = true;
					processEnter(e,_thisImg);
				});
				thisImg.addEventListener('touchend', function(e){
					win.preventScroll = false;
					processExit(e,_thisImg,_layers,_totalLayers,_shine);
				});
	        })(thisImg,layers,totalLayerElems,shineHTML);
	    } else {
	    	(function(_thisImg,_layers,_totalLayers,_shine) {
				thisImg.addEventListener('mousemove', function(e){
					processMovement(e,false,_thisImg,_layers,_totalLayers,_shine);
				});
	            thisImg.addEventListener('mouseenter', function(e){
					processEnter(e,_thisImg);
				});
				thisImg.addEventListener('mouseleave', function(e){
					processExit(e,_thisImg,_layers,_totalLayers,_shine);
				});
	        })(thisImg,layers,totalLayerElems,shineHTML);
	    }
	}

	function processMovement(e, touchEnabled, elem, layers, totalLayers, shine){

		var bdst = bd.scrollTop || htm.scrollTop,
			bdsl = bd.scrollLeft,
			pageX = (touchEnabled)? e.touches[0].pageX : e.pageX,
			pageY = (touchEnabled)? e.touches[0].pageY : e.pageY,
			offsets = elem.getBoundingClientRect(),
			w = elem.clientWidth || elem.offsetWidth || elem.scrollWidth, // width
			h = elem.clientHeight || elem.offsetHeight || elem.scrollHeight, // height
			wMultiple = 320/w,
			offsetX = 0.52 - (pageX - offsets.left - bdsl)/w, //cursor position X
			offsetY = 0.52 - (pageY - offsets.top - bdst)/h, //cursor position Y
			dy = (pageY - offsets.top - bdst) - h / 2, //@h/2 = center of container
			dx = (pageX - offsets.left - bdsl) - w / 2, //@w/2 = center of container
			yRotate = (offsetX - dx)*(0.07 * wMultiple), //rotation for container Y
			xRotate = (dy - offsetY)*(0.1 * wMultiple), //rotation for container X
			imgCSS = 'rotateX(' + xRotate + 'deg) rotateY(' + yRotate + 'deg)', //img transform
			arad = Math.atan2(dy, dx), //angle between cursor and center of container in RAD
			angle = arad * 180 / Math.PI - 90; //convert rad in degrees

		//get angle between 0-360
		if (angle < 0) {
			angle = angle + 360;
		}

		//container transform
		if(elem.firstChild.className.indexOf(' over') != -1){
			imgCSS += ' scale3d(1.07,1.07,1.07)';
		}
		elem.firstChild.style.transform = imgCSS;

		//gradient angle and opacity for shine
		shine.style.background = 'linear-gradient(' + angle + 'deg, rgba(255,255,255,' + (pageY - offsets.top - bdst)/h * 0.4 + ') 0%,rgba(255,255,255,0) 80%)';
		shine.style.transform = 'translateX(' + (offsetX * totalLayers) - 0.1 + 'px) translateY(' + (offsetY * totalLayers) - 0.1 + 'px)';

		//parallax for each layer
		var revNum = totalLayers;
		for(var ly=0;ly<totalLayers;ly++){
			layers[ly].style.transform = 'translateX(' + (offsetX * revNum) * ((ly * 2.5) / wMultiple) + 'px) translateY(' + (offsetY * totalLayers) * ((ly * 2.5) / wMultiple) + 'px)';
			revNum--;
		}
	}

	function processEnter(e, elem){
		elem.firstChild.className += ' over';
	}

	function processExit(e, elem, layers, totalLayers, shine){

		var container = elem.firstChild;

		container.className = container.className.replace(' over','');
		container.style.transform = '';
		shine.style.cssText = '';

		for(var ly=0;ly<totalLayers;ly++){
			layers[ly].style.transform = '';
		}

	}

}

	});

$(document).ready(function(){
	// addurllswitcher();
  if ($("#didomi-notice").length > 0){
    $('body').addClass("hasNotice");
  }
});

$(".highlight-button").click(function(){
  $('body').removeClass("hasNotice");
});
$(".didomi-components-button").click(function(){
  $('body').removeClass("hasNotice");
});

// when using range sliders,
//coordinates the input itself and the field close to it
$(".js-range").on("input",function(){
  var value = $(this).val();
  var percent = value / $(this).closest('.men__range_block').find('.js-range').attr("max") * 100;
  var size = $(this).closest('.men__range_block').find('.js-range').width() * percent / 100;
  $(this).closest('.men__range_block').find('.men__range_completed').css("width", "calc( " + percent + "% - calc( " + percent * 18 / 100 + "px)");
  $(this).closest('.men__range_block').find('.js-range').val(value);
});

$('.js-roisubmit').click(function(){
  var roiAccounts = $('#roic-accounts').val();
  var roiPosts = $('#roic-posts').val();
  if (roiAccounts != "" && roiPosts != ""){
  var timetologin = 1;
  var timetopost = 5;
  var weeksInAMonth = 4;
  var hoursWorkingInAMonth = 140;
  var monthsinayear = 12;
  var salary = 50000;
  var wastedTime = (roiAccounts * timetologin + roiPosts * timetopost) * weeksInAMonth;
  var wastePublishTime = 0.2 * wastedTime;
  wastedTime = wastedTime / 60;
  var wastedMoney = wastedTime * salary / hoursWorkingInAMonth / monthsinayear;


  wastePublishTime = wastePublishTime / 60;
  var wastedPublishMoney = wastePublishTime * salary / hoursWorkingInAMonth / monthsinayear;

  wastedTime = Math.round(wastedTime * 10) / 10;
  wastedMoney = Math.round((wastedMoney - wastedPublishMoney) * 100) / 100;

    $('.men__roic_step1').addClass('men__roic_step2');
    $('.men__roic_step1').removeClass('men__roic_step1');

    $('.js-roic-accounts').text(roiAccounts);
    $('.js-roic-posts').text(roiPosts);

    $('.js-roic-wastedTime').text(wastedTime + "h");
    $('.js-roic-wastedMoney').text(wastedMoney + "$");
  }
});

$('.men__roic_restart').click(function(){
  $('.men__roic_step2').addClass('men__roic_step1');
  $('.men__roic_step2').removeClass('men__roic_step2');
});

$('.js-popin-link').on('click', function(e){
  e.preventDefault();
  $( "body" ).addClass( "no-scroll" );
  // $( "html" ).addClass( "no-scroll" );
  $( "body" ).addClass( "popin-is-open" );
  var popinTarget = $(e.target).data('popin-target');
  $('.js-popin[data-popin-name="' + popinTarget + '"]').addClass('men__popin--visible');
})

$('.js-popin-close').on('click', function(){
  console.log("zezeez");
  $( "body" ).removeClass( "no-scroll" );
  $( "html" ).removeClass( "no-scroll" );
  $('.js-popin').removeClass('men__popin--visible');
});


/* Toast cookie */

function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for(var i = 0; i <ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
					c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
			}
	}
	return "";
}

function checkCookie() {
	var hasCookie = getCookie(toast_identifier);
	if (hasCookie != "") {
			$(".men_toast").addClass("men_toast--closed");
	}
}

$(".js-toast-close").on('click', function(e){
	setCookie(toast_identifier, "1", 30);
	$(".men_toast").addClass("men_toast--closed");
});


if ($('.men_toast').length > 0){
	var toast_identifier = $('.men_toast').data("identifier");
	checkCookie(toast_identifier);
}
